import deliverSetClearingApi from '@/api/delivery/delivery-set-clearing-api';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async cancel(_, form) {
      try {
        await deliverSetClearingApi.cancel(form);
        return Promise.resolve();
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async complete({dispatch}, {query}) {
      try {
        await deliverSetClearingApi.complete(query);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async completeMultiple({dispatch}, {query}) {
      try {
        await deliverSetClearingApi.completeMultiple(query);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async done(_, {query}) {
      try {
        await deliverSetClearingApi.done(query);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async fetchTree(_, {done}) {
      try {
        const treeData = await deliverSetClearingApi.fetchTree(done);
        return Promise.resolve(treeData.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async prepareForCredit(_, {query}) {
      try {
        const treeData = await deliverSetClearingApi.prepareCreditForReport(query);
        return Promise.resolve(treeData.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    }
  }
}
